import { Link } from "react-router-dom";
import { articles, categories } from "@/mocks/articles";

export default function LatestNews() {
  const latestArticles = [...articles].sort(
    (a, b) => new Date(b.published_at).getTime() - new Date(a.published_at).getTime()
  );

  return (
    <section className="py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新爆料
          </h2>
          <p className="text-sm text-foreground-500 mt-1">第一时间掌握娱乐圈最新动态</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 space-y-5">
            {latestArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-lg p-4 hover:bg-background-200/50 transition-all duration-200 cursor-pointer"
              >
                <div className="flex-shrink-0 w-full sm:w-48 h-32 rounded-lg overflow-hidden">
                  <img
                    src={article.thumbImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 min-w-0 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium">
                        {categories.find((c) => c.slug === article.category)?.name}
                      </span>
                      {article.is_hot && (
                        <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium flex items-center gap-1">
                          <span className="w-3 h-3 flex items-center justify-center"><i className="ri-fire-line"></i></span>
                          热
                        </span>
                      )}
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2 leading-snug font-heading">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mt-2 hidden sm:block">
                      {article.excerpt}
                    </p>
                  </div>
                  <div className="flex items-center gap-4 text-xs text-foreground-400 mt-3">
                    <span className="flex items-center gap-1">
                      <span className="w-3 h-3 flex items-center justify-center"><i className="ri-time-line"></i></span>
                      {article.published_at}
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="w-3 h-3 flex items-center justify-center"><i className="ri-eye-line"></i></span>
                      {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <span className="w-3 h-3 flex items-center justify-center"><i className="ri-chat-3-line"></i></span>
                      {article.comments}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="lg:col-span-1">
            <div className="sticky top-24">
              <div className="bg-background-50 rounded-lg p-5 mb-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-4 font-heading flex items-center gap-2">
                  <span className="w-5 h-5 flex items-center justify-center text-accent-500"><i className="ri-fire-line"></i></span>
                  热门标签
                </h3>
                <div className="flex flex-wrap gap-2">
                  {Array.from(new Set(articles.flatMap((a) => a.tags))).slice(0, 15).map((tag) => (
                    <Link
                      key={tag}
                      to={`/category/remen`}
                      className="px-3 py-1.5 rounded-full bg-background-200 text-foreground-600 text-xs hover:bg-primary-100 hover:text-primary-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {tag}
                    </Link>
                  ))}
                </div>
              </div>

              <div className="bg-background-50 rounded-lg p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-4 font-heading">关于黑料官网</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-4">
                  黑料官网是专注于收录和分享最新真实黑料内容的权威爆料平台，汇聚海量独家内幕、明星黑料、网红黑料及各类热门事件深度揭秘。
                </p>
                <Link
                  to="/about"
                  className="text-xs text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer"
                >
                  了解更多
                  <span className="w-3 h-3 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}